import {
  IonAvatar,
  IonButton,
  IonHeader,
  IonIcon,
  IonImg,
  IonModal,
  IonRow,
} from "@ionic/react";
import * as d3 from "d3";
import { arrowForward, checkmarkCircleOutline, close } from "ionicons/icons";
import ZoomSvg from "../../assets/svg/zoom.svg";

import { ReactSVG } from "react-svg";

import "./ReportDamageModal.css";

import { svgMapping, tractorMapping } from "../../data/vehicleMapping";
import { inspectionRouteMapping } from "../../data/InspectionRoute";
import { useEffect, useRef, useState } from "react";
interface Step1Props {
  side: string;
  type: string;
  setStep: (step: number) => void;
  setSelectedElement: (element: string) => void;
  selectedElement: string;
}

const Step1: React.FC<Step1Props> = ({
  side,
  type,
  setStep,
  selectedElement,
  setSelectedElement,
}) => {
  let currentSvg = svgMapping(side, type);

  return (
    <div>
      <IonRow className="ReportDamageModal-title">
        Sélectionnez la zone concernée par le dommage
      </IonRow>
      <IonRow className="ion-justify-content-center">
        <IonButton
          color="warning"
          expand="block"
          className={
            !selectedElement
              ? "ReportDamageModal-button-hidden"
              : "ReportDamageModal-button"
          }
        >
          <IonIcon
            icon={checkmarkCircleOutline}
            color="primary"
            size=""
            className="PathCard-icon"
            slot="start"
          />
          {selectedElement
            ? tractorMapping[selectedElement as string]?.label
            : ""}
        </IonButton>
      </IonRow>

      <IonRow className="ion-justify-content-center">
        {/* <IonIcon
                  src={TractorLeftSvg}
                  className="ReportDamageModal-tractor  ion-justify-content-center"
                /> */}

        <ReactSVG
          className="ReportDamageModal-tractor"
          src={currentSvg}
          afterInjection={(svg) => {
            const width = 300;
            const height = 200;

            d3.select(svg as SVGSVGElement).attr("width", width);

            let zoom = d3.zoom().on("zoom", (e) => {
              d3.select(svg as SVGSVGElement)
                .select("g")
                .attr("transform", e.transform);
            });
            d3.select(svg as SVGSVGElement)
              .select("g")
              .call(zoom as any);

            d3.select(svg as SVGSVGElement)
              .selectAll("path")
              .each(function () {
                const ctx = this as SVGSVGElement;
                const elementId = ctx?.id.split("-")[0];
                if (!elementId) return;
                if (elementId === selectedElement) {
                  d3.selectAll("path").transition().style("opacity", "0.2");
                  d3.select(this).transition().style("opacity", "1");
                }
                d3.select(this).on("click", () => {
                  setSelectedElement(elementId);
                });
              });
          }}
        />
      </IonRow>

      <div className="ReportDamageModal-footer">
        {!selectedElement ? (
          <>
            {" "}
            <IonRow className="ReportDamageModal-info  ion-justify-content-center">
              Vous pouvez zoomer sur le schéma
            </IonRow>
            <IonRow className="ion-justify-content-center">
              <IonIcon src={ZoomSvg} className="ReportDamageModal-icon" />
            </IonRow>
          </>
        ) : (
          <>
            <IonRow className="ReportDamageModal-text ion-justify-content-center">
              {type && side ? inspectionRouteMapping()[type][side].name : ""}
            </IonRow>
            <IonButton
              color={"success"}
              expand="block"
              onClick={() => setStep(1)}
            >
              Continuer
              <IonIcon icon={arrowForward} slot="end" />
            </IonButton>
          </>
        )}
      </div>
    </div>
  );
};

export default Step1;
